/**
 * An object containing properties for table events
 */
export class TableEvent {
  /**
   * The object associated with the current row
   */
  row: any;

  /**
   * The currently selected rows, if applicable
   */
  selectedRows?: any[];
}
